// extracted by mini-css-extract-plugin
export default {"container":"SuggestedUser_container__n-h9p","link":"SuggestedUser_link__U-kSU","username":"SuggestedUser_username__q0-no","button":"SuggestedUser_button__n1-x9"};